import { Component, OnInit } from '@angular/core';
import { ApiService } from '../../services/API/api.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-order-success',
  templateUrl: './order-success.component.html',
  styleUrl: './order-success.component.scss'
})
export class OrderSuccessComponent implements OnInit {
  orderId: string = '';

  constructor(private apiService: ApiService,private route: ActivatedRoute) {
    this.route.params.subscribe(params => {
      if(params.id){
        this.orderId = params.id;
      }
    });
  }

  ngOnInit(): void {
    localStorage.removeItem('couponApplied')
    localStorage.removeItem('couponValue')
    localStorage.removeItem('couponCode')
    localStorage.removeItem('couponType')
    localStorage.removeItem('couponId')
    // delete cart items if order success
    const token = localStorage.getItem('bbq_token');
    const guestMode = sessionStorage.getItem('guestMode');
    if(token){
      this.apiService.emptyCart().subscribe({});
    }else if(guestMode){
      sessionStorage.removeItem('cartItems');
    }
    sessionStorage.removeItem('cartItems');
    this.updatePaymentState()
  }

  private updatePaymentState(): void {
    this.apiService.updatePaymentState({ payment_state: 'success' }, this.orderId).subscribe({});
  }
}
